import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import moment from 'moment'

import {
  Accordion,
  AccordionItem,
  Badge,
  Button,
  Exam,
  Heading,
  Link,
  Loader,
  OralExam,
  Tabs,
} from '@/components'
import { CheckboxCustom, Input } from '@/components/form'
import { StudentLayout } from '@/layouts'
import { EXAM_TYPE_ORAL } from '@/stores/models/exam'
import { formatSecondsToHHMMSS } from '@/utils/helpers'
import './ExamHomePage.scss'

const EXAM_HOME_PAGE_TAB_EXAM = 'EXAM'
const EXAM_HOME_PAGE_TAB_ORAL_EXAM = 'ORAL_EXAM'

const EXAM_HOME_PAGE_TABS = [
  { id: EXAM_HOME_PAGE_TAB_EXAM, text: 'Written Exam' },
  {
    id: EXAM_HOME_PAGE_TAB_ORAL_EXAM,
    text: (
      <>
        ChatDME&trade; Oral Exam{' '}
        <Badge className="ExamHomePage__tab-beta-label" type="beta">
          BETA
        </Badge>
      </>
    ),
    'aria-label': 'ChatDME Oral Exam (Beta)',
  },
]

const EXAM_HOME_PAGE_HOME_VIEW = 'HOME'

const EXAM_HOME_PAGE_PRACTICE_VIEW = 'PRACTICE'
const EXAM_HOME_PAGE_REVIEW_PRACTICE_VIEW = 'PRACTICE_REVIEW'

const EXAM_HOME_PAGE_TEST_VIEW = 'TEST'
const EXAM_HOME_PAGE_REVIEW_TEST_VIEW = 'TEST_REVIEW'

const EXAM_HOME_PAGE_REVIEW_EXAM_VIEW = 'EXAM_REVIEW'
const EXAM_HOME_PAGE_PRACTICE_ORAL_EXAM_VIEW = 'PRACTICE_ORAL_EXAM'
const EXAM_HOME_PAGE_REVIEW_PRACTICE_ORAL_EXAM_VIEW =
  'PRACTICE_ORAL_EXAM_REVIEW'
const EXAM_HOME_PAGE_REVIEW_ORAL_EXAM_VIEW = 'ORAL_EXAM_REVIEW'

class ExamHomePageExamView extends Component {
  render() {
    const { exam, isPractice, onClickBack } = this.props
    return (
      <Exam exam={exam} isPractice={isPractice} onClickBack={onClickBack} />
    )
  }
}

class ExamHomePageReviewView extends Component {
  state = {
    active: null,
    isLoading: true,
  }
  componentDidMount() {
    this.loadExamAttempts()
  }
  loadExamAttempts = () => {
    const { loadExamAttempts } = this.props
    return loadExamAttempts().then(() => this.setState({ isLoading: false }))
  }
  onChange = (active) => {
    this.setState({ active })
  }
  renderExamAttempt = (examAttempt, isPractice = false) => {
    const { onClickReviewExam } = this.props
    const { attempt, completedAt, passed, score } = examAttempt
    return (
      <div
        className="ExamHomePage__exam-attempt"
        key={`exam-attempt-${attempt}`}
      >
        <div className="ExamHomePage__exam-attempt-item">
          <Heading is4>Attempt {attempt}</Heading>
        </div>
        <div className="ExamHomePage__exam-attempt-item">
          <Heading is5>
            {passed ? (
              <i className="fa fa-check" />
            ) : (
              <i className="fa fa-times" />
            )}
          </Heading>
        </div>
        <div className="ExamHomePage__exam-attempt-item">
          <Heading is5>{Math.floor(score * 100)}%</Heading>
        </div>
        <div className="ExamHomePage__exam-attempt-item">
          <Heading is5>
            {moment(new Date(completedAt)).format('YYYY-MM-DD HH:mm:ss')}
          </Heading>
        </div>
        <div className="ExamHomePage__exam-attempt-item">
          <Button isInfo onClick={() => onClickReviewExam(attempt, isPractice)}>
            Details
          </Button>
        </div>
      </div>
    )
  }
  render() {
    const { examAttempts, isPractice, onBack, practiceExamAttempts } =
      this.props
    const { active, isLoading } = this.state
    return (
      <div className="ExamHomePage__review">
        <Button className="ExamHomePage__review-back" onClick={onBack}>
          Back
        </Button>
        <div className="ExamHomePage__review-accordion">
          {!isLoading ? (
            <Accordion
              active={
                active || [
                  isPractice
                    ? EXAM_HOME_PAGE_REVIEW_PRACTICE_VIEW
                    : EXAM_HOME_PAGE_REVIEW_TEST_VIEW,
                ]
              }
              onChange={this.onChange}
            >
              <AccordionItem
                id={EXAM_HOME_PAGE_REVIEW_TEST_VIEW}
                key={EXAM_HOME_PAGE_REVIEW_TEST_VIEW}
                primaryLabel={<Heading is2>FAA Exam Attempts</Heading>}
              >
                {examAttempts && examAttempts.length ? (
                  <div className="ExamHomePage__exam-attempts">
                    <div className="ExamHomePage__exam-attempts-header">
                      <div className="ExamHomePage__exam-attempts-header-item">
                        <span>Attempt</span>
                      </div>
                      <div className="ExamHomePage__exam-attempts-header-item">
                        <span>Result</span>
                      </div>
                      <div className="ExamHomePage__exam-attempts-header-item">
                        <span>Score</span>
                      </div>
                      <div className="ExamHomePage__exam-attempts-header-item">
                        <span>Completed At</span>
                      </div>
                      <div className="ExamHomePage__exam-attempts-header-item" />
                    </div>
                    {examAttempts.map((attempt) =>
                      this.renderExamAttempt(attempt),
                    )}
                  </div>
                ) : (
                  <div className="ExamHomePage__exam-attempts-empty">
                    No Attempts
                  </div>
                )}
              </AccordionItem>
              <AccordionItem
                id={EXAM_HOME_PAGE_REVIEW_PRACTICE_VIEW}
                key={EXAM_HOME_PAGE_REVIEW_PRACTICE_VIEW}
                primaryLabel={<Heading is2>FAA Practice Exam Attempts</Heading>}
              >
                {practiceExamAttempts && practiceExamAttempts.length ? (
                  <div className="ExamHomePage__exam-attempts">
                    <div className="ExamHomePage__exam-attempts-header">
                      <div className="ExamHomePage__exam-attempts-header-item">
                        <span>Attempt</span>
                      </div>
                      <div className="ExamHomePage__exam-attempts-header-item">
                        <span>Passed</span>
                      </div>
                      <div className="ExamHomePage__exam-attempts-header-item">
                        <span>Score</span>
                      </div>
                      <div className="ExamHomePage__exam-attempts-header-item">
                        <span>Completed At</span>
                      </div>
                      <div className="ExamHomePage__exam-attempts-header-item" />
                    </div>
                    {practiceExamAttempts.map((attempt) =>
                      this.renderExamAttempt(attempt, true),
                    )}
                  </div>
                ) : (
                  <div className="ExamHomePage__exam-attempts-empty">
                    No Attempts
                  </div>
                )}
              </AccordionItem>
            </Accordion>
          ) : (
            <Loader />
          )}
        </div>
      </div>
    )
  }
}

class ExamHomePageReviewExamView extends Component {
  componentDidMount() {
    this.loadExamAttempt()
  }
  loadExamAttempt = () => {
    const { loadExamAttempt } = this.props
    return loadExamAttempt()
  }
  renderResultsItem = (item, index) => {
    const {
      learningObjectives: itemLearningObjectives,
      passed: itemHasPassed,
      question: itemQuestion,
      activity: itemActivity,
    } = item || {}
    return (
      <div
        className="ExamHomePage__results-item"
        key={`ExamHomePage__results-item-${index}`}
      >
        <Heading className="ExamHomePage__results-item-number" is3>
          Question {index + 1}:
        </Heading>
        <div className="ExamHomePage__results-item-question">
          <Heading
            className="ExamHomePage__results-item-question-title"
            dangerouslySetInnerHTML={{ __html: itemQuestion }}
            is2
          />
          <div className="ExamHomePage__results-item-question-icon">
            <span>
              {itemHasPassed ? (
                <i className="fa fa-check" />
              ) : (
                <i className="fa fa-close" />
              )}
            </span>
          </div>
        </div>
        {itemLearningObjectives &&
          itemLearningObjectives.length &&
          !itemHasPassed && (
            <div className="ExamHomePage__results-item-learning-objectives">
              {itemLearningObjectives.map((lo, loIndex) => (
                <p
                  className="ExamHomePage__results-item-learning-objective"
                  key={`ExamHomePage__results-item-learning-objective-${loIndex}`}
                >
                  * {lo}
                </p>
              ))}
            </div>
          )}
        {itemActivity && itemActivity.goodToKnow && (
          <div className="ExamHomePage__results-block">
            <span className="ExamHomePage__results-item-answer-choice">
              Feedback:
            </span>
            <p dangerouslySetInnerHTML={{ __html: itemActivity.goodToKnow }} />
          </div>
        )}
        {itemActivity &&
          itemActivity.type === 'multiple_choice' &&
          !itemHasPassed && (
            <div className="ExamHomePage__results-block">
              <span className="ExamHomePage__results-item-answer-choice">
                Answer Choices:
              </span>
              {itemActivity.choices.map((choice) => {
                return (
                  <span
                    key={`activity-choice-id-${choice.id}`}
                    className="ExamHomePage__results-item-answer-choice-content"
                  >
                    {choice.content}
                  </span>
                )
              })}
            </div>
          )}
      </div>
    )
  }
  render() {
    const { examAttempt, examAttemptReview, onClickBack } = this.props
    const { completedAt, results, score } = examAttempt || {}
    const { attempt, isPractice: isPracticeReview } = examAttemptReview || {}
    return (
      <div className="ExamHomePage__review-exam-attempt">
        <Button
          className="ExamHomePage__review-back"
          onClick={() => onClickBack(isPracticeReview)}
        >
          Back
        </Button>
        {examAttempt ? (
          <div className="ExamHomePage__block">
            <Heading is1>
              {isPracticeReview ? 'Practice Exam' : 'Exam'} Attempt #{attempt}
            </Heading>
            <div>
              <Heading is2>
                Completed At:{' '}
                {moment(new Date(completedAt)).format('YYYY-MM-DD HH:mm:ss')}
              </Heading>
              <Heading is2>
                Score: {Math.floor(score * 100 * 100) / 100}%
              </Heading>
            </div>
            <div className="ExamHomePage__results">
              {results.map(this.renderResultsItem)}
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </div>
    )
  }
}

class OralExamHomePageReviewView extends Component {
  state = {
    isLoading: true,
  }
  componentDidMount() {
    this.loadExamAttempts()
  }
  loadExamAttempts = () => {
    const { loadExamAttempts } = this.props
    return loadExamAttempts().then(() => this.setState({ isLoading: false }))
  }
  renderExamAttempt = (examAttempt) => {
    const { onClickReviewExam } = this.props
    const { attempt, completedAt, passed, score } = examAttempt
    return (
      <div
        className="ExamHomePage__exam-attempt"
        key={`exam-attempt-${attempt}`}
      >
        <div className="ExamHomePage__exam-attempt-item">
          <Heading is4>Attempt {attempt}</Heading>
        </div>
        <div className="ExamHomePage__exam-attempt-item">
          <Heading is5>
            {passed ? (
              <i className="fa fa-check" />
            ) : (
              <i className="fa fa-times" />
            )}
          </Heading>
        </div>
        <div className="ExamHomePage__exam-attempt-item">
          <Heading is5>{Math.floor(score * 100)}%</Heading>
        </div>
        <div className="ExamHomePage__exam-attempt-item">
          <Heading is5>
            {moment(new Date(completedAt)).format('YYYY-MM-DD HH:mm:ss')}
          </Heading>
        </div>
        <div className="ExamHomePage__exam-attempt-item">
          <Button isInfo onClick={() => onClickReviewExam(attempt)}>
            Details
          </Button>
        </div>
      </div>
    )
  }
  render() {
    const { practiceExamAttempts, onBack } = this.props
    const { isLoading } = this.state
    return (
      <div className="ExamHomePage__review">
        <Button className="ExamHomePage__review-back" onClick={onBack}>
          Back
        </Button>
        <Heading className="ExamHomePage__review-oral-exam-title" is2>
          Practice Oral Exam Attempts
        </Heading>
        {isLoading ? (
          <Loader />
        ) : practiceExamAttempts && practiceExamAttempts.length ? (
          <div className="ExamHomePage__exam-attempts">
            <div className="ExamHomePage__exam-attempts-header">
              <div className="ExamHomePage__exam-attempts-header-item">
                <span>Attempt</span>
              </div>
              <div className="ExamHomePage__exam-attempts-header-item">
                <span>Passed</span>
              </div>
              <div className="ExamHomePage__exam-attempts-header-item">
                <span>Score</span>
              </div>
              <div className="ExamHomePage__exam-attempts-header-item">
                <span>Completed At</span>
              </div>
              <div className="ExamHomePage__exam-attempts-header-item" />
            </div>
            {practiceExamAttempts.map((attempt) =>
              this.renderExamAttempt(attempt),
            )}
          </div>
        ) : (
          <div className="ExamHomePage__exam-attempts-empty">No Attempts</div>
        )}
      </div>
    )
  }
}

class OralExamHomePageReviewExamView extends Component {
  componentDidMount() {
    this.loadExamAttempt()
  }
  loadExamAttempt = () => {
    const { loadExamAttempt } = this.props
    return loadExamAttempt()
  }
  renderResultsItem = (item, index) => {
    const {
      learningObjectives: itemLearningObjectives,
      passed: itemHasPassed,
      question: itemQuestion,
      activity: itemActivity,
    } = item || {}
    return (
      <div
        className="ExamHomePage__results-item"
        key={`ExamHomePage__results-item-${index}`}
      >
        <Heading className="ExamHomePage__results-item-number" is3>
          Question {index + 1}:
        </Heading>
        <div className="ExamHomePage__results-item-question">
          <Heading
            className="ExamHomePage__results-item-question-title"
            dangerouslySetInnerHTML={{ __html: itemQuestion }}
            is2
          />
          <div className="ExamHomePage__results-item-question-icon">
            <span>
              {itemHasPassed ? (
                <i className="fa fa-check" />
              ) : (
                <i className="fa fa-close" />
              )}
            </span>
          </div>
        </div>
        {itemLearningObjectives &&
          itemLearningObjectives.length &&
          !itemHasPassed && (
            <div className="ExamHomePage__results-item-learning-objectives">
              {itemLearningObjectives.map((lo, loIndex) => (
                <p
                  className="ExamHomePage__results-item-learning-objective"
                  key={`ExamHomePage__results-item-learning-objective-${loIndex}`}
                >
                  * {lo}
                </p>
              ))}
            </div>
          )}
        {itemActivity && itemActivity.goodToKnow && (
          <div className="ExamHomePage__results-block">
            <span className="ExamHomePage__results-item-answer-choice">
              Feedback:
            </span>
            <p dangerouslySetInnerHTML={{ __html: itemActivity.goodToKnow }} />
          </div>
        )}
      </div>
    )
  }
  render() {
    const { examAttempt, examAttemptReview, onClickBack } = this.props
    const { completedAt, results, score } = examAttempt || {}
    const { attempt } = examAttemptReview || {}
    return (
      <div className="ExamHomePage__review-exam-attempt">
        <Button
          className="ExamHomePage__review-back"
          onClick={() => onClickBack()}
        >
          Back
        </Button>
        {examAttempt ? (
          <div className="ExamHomePage__block">
            <Heading is1>Practice Oral Exam Attempt #{attempt}</Heading>
            <div>
              <Heading is2>
                Completed At:{' '}
                {moment(new Date(completedAt)).format('YYYY-MM-DD HH:mm:ss')}
              </Heading>
              <Heading is2>
                Score: {Math.floor(score * 100 * 100) / 100}%
              </Heading>
            </div>
            <div className="ExamHomePage__results">
              {results.map(this.renderResultsItem)}
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </div>
    )
  }
}

class OralExamHomePageContent extends Component {
  componentDidMount() {
    const { loadOralExamStatuses } = this.props
    loadOralExamStatuses()
  }
  render() {
    const {
      defaultQuestionCount,
      isLoadingOralExamStatuses,
      learningObjectives,
      loadOralExamAttempt,
      loadOralExamAttempts,
      numQuestions,
      onChangeFilter,
      onChangeNumQuestions,
      onClickOralExamBack,
      onClickReviewOralExam,
      onClickReviewOralExamBack,
      onClickReviewPracticeOralExam,
      onClickStartPracticeOralExam,
      oralExamAttempt,
      oralExamAttemptReview,
      practiceOralExam,
      practiceOralExamAttempts,
      view,
    } = this.props
    const {
      filters: practiceOralExamFilters,
      isDone: isDonePracticeOralExam,
      isReady: isReadyPracticeOralExam,
      isStarted: isStartedPracticeOralExam,
      status: practiceOralExamStatus,
    } = practiceOralExam || {}
    if (isLoadingOralExamStatuses) {
      return <Loader />
    }
    if (view === EXAM_HOME_PAGE_PRACTICE_ORAL_EXAM_VIEW) {
      return (
        <OralExam
          exam={practiceOralExam}
          isPractice
          onClickBack={onClickOralExamBack}
        />
      )
    }
    if (view === EXAM_HOME_PAGE_REVIEW_PRACTICE_ORAL_EXAM_VIEW) {
      return (
        <OralExamHomePageReviewView
          loadExamAttempts={loadOralExamAttempts}
          onBack={onClickOralExamBack}
          onClickReviewExam={onClickReviewOralExam}
          practiceExamAttempts={practiceOralExamAttempts}
        />
      )
    }
    if (view === EXAM_HOME_PAGE_REVIEW_ORAL_EXAM_VIEW) {
      return (
        <OralExamHomePageReviewExamView
          examAttempt={oralExamAttempt}
          examAttemptReview={oralExamAttemptReview}
          loadExamAttempt={loadOralExamAttempt}
          onClickBack={onClickReviewOralExamBack}
        />
      )
    }
    return (
      <div className="ExamHomePage__content">
        <div>
          <Heading is2>FAA Practice ChatDME&trade; Oral Exam</Heading>
          <p>
            ChatDME&trade; is the first AI-powered oral exam simulator of its
            kind giving you a realistic, conversational experience that mirrors
            what you&apos;ll face in your actual FAA oral exam. Use it to learn,
            review, and build confidence.  After each session, you&apos;ll
            receive a full performance breakdown showing which questions you
            answered correctly, which you missed, and detailed feedback
            explaining the right answers.
            <br />
            <br />
            Want to zero in on your weak spots? Select specific categories to
            build a targeted Practice Oral Exam around the areas that need the
            most work. Prefer a broader review? Leave categories unselected and
            you&apos;ll receive randomized questions drawn from the full
            question pool.
          </p>
          <div className="ExamHomePage__block">
            <Heading className="ExamHomePage__content-label" is3>
              Instructions
            </Heading>
            <ul>
              <li>- [Optional] Select categories from the list below</li>
              <li>
                - Choose the number of questions you would like to practice
              </li>
              <li>- Complete the Practice Oral Exam</li>
              <li>- Review your results</li>
            </ul>
          </div>
          <div className="ExamHomePage__beta-footer">
            <p>
              * This feature is currently in beta. We are actively improving it
              and welcome your feedback.
            </p>
          </div>
          {!practiceOralExamStatus || isDonePracticeOralExam ? (
            <>
              <div className="ExamHomePage__filter">
                <Heading className="ExamHomePage__content-label" is3>
                  Categories
                </Heading>
                <p className="ExamHomePage__subtext">
                  If no categories are selected, your practice session will
                  contain random questions from all categories.
                </p>
                <div className="ExamHomePage__categories">
                  {practiceOralExamFilters &&
                    practiceOralExamFilters.map(
                      (practiceOralExamFilter, index) => (
                        <div
                          key={`OralExamHomePageContent__practice-oral-exam-filter-${
                            index + 1
                          }`}
                        >
                          <CheckboxCustom
                            checked={
                              learningObjectives &&
                              learningObjectives.indexOf(
                                practiceOralExamFilter,
                              ) !== -1
                            }
                            isBlock
                            name="practiceOralExamFilters"
                            onChange={onChangeFilter}
                            text={practiceOralExamFilter}
                            value={practiceOralExamFilter}
                          />
                        </div>
                      ),
                    )}
                </div>
              </div>
              <div className="ExamHomePage__filter">
                <Heading className="ExamHomePage__content-label" is3>
                  Number of Questions
                </Heading>
                <p className="ExamHomePage__subtext">
                  The default (maximum) is set to the number of questions that
                  will appear in Test mode
                </p>
                <div>
                  <Input
                    className="ExamHomePage__num-questions"
                    onChange={onChangeNumQuestions}
                    value={
                      numQuestions === '' || numQuestions === 0 || numQuestions
                        ? `${numQuestions}`
                        : defaultQuestionCount
                    }
                  />
                </div>
              </div>
            </>
          ) : null}
          <div className="ExamHomePage__buttons">
            <Button
              className="ExamHomePage__button"
              onClick={onClickReviewPracticeOralExam}
            >
              Review Past Practice Oral Exams
            </Button>
            <Button
              className="ExamHomePage__button"
              isInfo
              onClick={onClickStartPracticeOralExam}
            >
              {isReadyPracticeOralExam || isStartedPracticeOralExam
                ? 'Continue Practice Oral Exam'
                : 'Begin Practice Oral Exam'}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

class ExamHomePageContent extends Component {
  componentDidMount() {
    const { loadExamStatuses } = this.props
    loadExamStatuses()
  }
  render() {
    const {
      // courseTitle,
      defaultQuestionCount,
      exam,
      examAttempt,
      examAttemptReview,
      examAttempts,
      examEndless,
      isLoadingExamStatuses,
      learningObjectives,
      loadExamAttempt,
      loadExamAttempts,
      numQuestions,
      onChangeFilter,
      onChangeNumQuestions,
      onClickBack,
      onClickHome,
      onClickReviewBack,
      onClickReviewExam,
      onClickReviewPractice,
      onClickReviewTest,
      onClickStartPractice,
      onClickStartTest,
      practiceExam,
      practiceExamAttempts,
      view,
    } = this.props
    if (isLoadingExamStatuses) {
      return <Loader />
    } else if (view === EXAM_HOME_PAGE_TEST_VIEW) {
      return <ExamHomePageExamView exam={exam} onClickBack={onClickBack} />
    } else if (view === EXAM_HOME_PAGE_PRACTICE_VIEW) {
      return (
        <ExamHomePageExamView
          exam={practiceExam}
          isPractice
          onClickBack={onClickBack}
        />
      )
    } else if (
      view === EXAM_HOME_PAGE_REVIEW_TEST_VIEW ||
      view === EXAM_HOME_PAGE_REVIEW_PRACTICE_VIEW
    ) {
      return (
        <ExamHomePageReviewView
          examAttempts={examAttempts}
          isPractice={view === EXAM_HOME_PAGE_REVIEW_PRACTICE_VIEW}
          loadExamAttempts={loadExamAttempts}
          onBack={onClickHome}
          onClickReviewExam={onClickReviewExam}
          practiceExamAttempts={practiceExamAttempts}
        />
      )
    } else if (view === EXAM_HOME_PAGE_REVIEW_EXAM_VIEW) {
      return (
        <ExamHomePageReviewExamView
          examAttempt={examAttempt}
          examAttemptReview={examAttemptReview}
          loadExamAttempt={loadExamAttempt}
          onClickBack={onClickReviewBack}
        />
      )
    }

    const {
      examPassCount,
      examPassed,
      examTimeEnabled,
      isReady: isReadyExam,
      isStarted: isStartedExam,
      numExamPassed,
      scoreRequired: examScoreRequired,
      timeLimit,
      timeRemaining,
    } = exam || {}
    const {
      filters: practiceExamFilters,
      isDone: isDonePracticeExam,
      isReady: isReadyPracticeExam,
      isStarted: isStartedPracticeExam,
      status: practiceExamStatus,
    } = practiceExam || {}
    return (
      <div className="ExamHomePage__content">
        <div>
          <Heading is2>FAA Written Exam</Heading>
          {examPassed ? (
            <p>
              Congratulations, you have completed the Exam for the Course!
              <br />
              You can review the results for your Exams by clicking Review.
              <br />
              <br />
              If you would like to continue practicing, you can create your own
              custom Practice Exam below!
            </p>
          ) : (
            <>
              <p>
                {/*Welcome to the Exam for{' '}
                <span className="ExamHomePage__bold">{courseTitle}</span>!
                <br />
                <br />*/}
                This mode simulates a high stakes FAA written exam. You will
                complete the exam under test-like conditions. Use the results at
                the end of the exam as a guide on what to study / practice.
                Individual question results and correct answers are not shown,
                just as on the actual FAA exam.
                <br />
                <br />
                In order to pass this Exam, you will need to score a minimum of{' '}
                <span className="ExamHomePage__bold">
                  {examScoreRequired}%
                </span>{' '}
                or higher.
                <br />
                <br />
                {examPassCount && (
                  <span>
                    You must pass this Exam {examPassCount} times in order to
                    complete the Course. You have currently passed{' '}
                    {numExamPassed > examPassCount
                      ? examPassCount
                      : numExamPassed}{' '}
                    / {examPassCount} times.
                  </span>
                )}
                <br />
                <br />
                If you would like to practice before taking the Exam, you may
                create a custom{' '}
                <span className="ExamHomePage__bold">Practice Exam</span> below!
              </p>
              <div className="ExamHomePage__block">
                <Heading className="ExamHomePage__content-label" is3>
                  Instructions
                </Heading>
                <ul>
                  <li>- Answer {defaultQuestionCount} Questions</li>
                  <li>
                    - Complete the Exam with a score of {examScoreRequired} or
                    higher
                  </li>
                  <li>- Attempt Exam until you reach a passing score</li>
                  {examPassCount && (
                    <li>- Pass the Exam {examPassCount} times</li>
                  )}
                  {examTimeEnabled && timeRemaining && (
                    <li>
                      -{' '}
                      {isStartedExam
                        ? `Time remaining: ${formatSecondsToHHMMSS(
                            timeRemaining,
                          )}`
                        : `Complete within ${formatSecondsToHHMMSS(timeLimit)}`}
                    </li>
                  )}
                </ul>
              </div>
            </>
          )}
          <div className="ExamHomePage__buttons">
            <Button
              className="ExamHomePage__button"
              onClick={onClickReviewTest}
            >
              Review Past Exams
            </Button>
            {(!examPassed || examEndless) && (
              <Button
                className="ExamHomePage__button"
                isInfo
                onClick={onClickStartTest}
              >
                {isReadyExam || isStartedExam ? 'Continue Exam' : 'Start Exam'}
              </Button>
            )}
          </div>
        </div>
        <div className="ExamHomePage__practice">
          <Heading is2>FAA Practice Exam</Heading>
          <p>
            This mode is designed for learning and review. After completing the
            Exam, you will see which questions you answered correctly and
            incorrectly, along with the feedback explaining the correct answers
            for any missed questions.
            <br />
            <br />
            By selecting specific categories, you can filter the questions that
            will appear in your customized Practice Exam to target areas that
            you feel you need to work on. If no categories are selected, you
            will be given random questions from the entire pool of questions
            available.
          </p>
          <div className="ExamHomePage__block">
            <Heading className="ExamHomePage__content-label" is3>
              Instructions
            </Heading>
            <ul>
              <li>- [Optional] Select categories from the list below</li>
              <li>
                - Choose the number of questions you would like to practice
              </li>
              <li>- Complete the Practice Exam</li>
              <li>- Review your results</li>
            </ul>
          </div>
          {!practiceExamStatus || isDonePracticeExam ? (
            <>
              <div className="ExamHomePage__filter">
                <Heading className="ExamHomePage__content-label" is3>
                  Categories
                </Heading>
                <p className="ExamHomePage__subtext">
                  If no categories are selected, your practice session will
                  contain random questions from all categories.
                </p>
                <div className="ExamHomePage__categories">
                  {practiceExamFilters &&
                    practiceExamFilters.map((practiceExamFilter, index) => (
                      <div
                        key={`ExamHomePageContent__practice-exam-filter-${
                          index + 1
                        }`}
                      >
                        <CheckboxCustom
                          checked={
                            learningObjectives &&
                            learningObjectives.indexOf(practiceExamFilter) !==
                              -1
                          }
                          isBlock
                          name="practiceExamFilters"
                          onChange={onChangeFilter}
                          text={practiceExamFilter}
                          value={practiceExamFilter}
                        />
                      </div>
                    ))}
                </div>
              </div>
              <div className="ExamHomePage__filter">
                <Heading className="ExamHomePage__content-label" is3>
                  Number of Questions
                </Heading>
                <p className="ExamHomePage__subtext">
                  The default (maximum) is set to the number of questions that
                  will appear in Test mode
                </p>
                <div>
                  <Input
                    className="ExamHomePage__num-questions"
                    onChange={onChangeNumQuestions}
                    value={
                      numQuestions === '' || numQuestions === 0 || numQuestions
                        ? `${numQuestions}`
                        : defaultQuestionCount
                    }
                  />
                </div>
              </div>
            </>
          ) : null}
          <div className="ExamHomePage__buttons">
            <Button
              className="ExamHomePage__button"
              onClick={onClickReviewPractice}
            >
              Review Past Practice Exams
            </Button>
            <Button
              className="ExamHomePage__button"
              isInfo
              onClick={onClickStartPractice}
            >
              {isReadyPracticeExam || isStartedPracticeExam
                ? 'Continue Practice Exam'
                : 'Begin Practice Exam'}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

const initialState = {
  exam: null,
  examAttempt: null,
  examAttemptReview: null,
  examAttempts: [],
  isLoadingExamStatuses: false,
  isLoadingOralExamStatuses: false,
  practiceExam: null,
  practiceExamAttempts: [],
  practiceOralExam: null,
  oralExamAttempt: null,
  oralExamAttemptReview: null,
  practiceOralExamAttempts: [],
  tab: EXAM_HOME_PAGE_TAB_EXAM,
  /*
    Views
    - home
    - test
    - test review
    - practice
    - practice review
  */
  view: EXAM_HOME_PAGE_HOME_VIEW,
}

@inject('contentStore', 'uiStore')
@observer
export default class ExamHomePage extends Component {
  state = {
    ...initialState,
  }
  changeTab = (tab) => this.setState({ tab: tab.id })
  changeView = (view) => this.setState({ view })
  loadExamAttempt = () => {
    const { contentStore } = this.props
    const { examAttemptReview } = this.state
    const { attempt, isPractice } = examAttemptReview || {}
    return contentStore
      .loadExamAttempt(attempt, isPractice)
      .then((examAttempt) => this.setState({ examAttempt }))
  }
  loadExamAttempts = () => {
    const { contentStore } = this.props
    return Promise.all([
      contentStore.loadExamAttempts(),
      contentStore.loadExamAttempts(true), // isPractice
    ]).then(([examAttempts, practiceExamAttempts]) =>
      this.setState({ examAttempts, practiceExamAttempts }),
    )
  }
  loadOralExamStatuses = () => {
    const { contentStore } = this.props
    this.setState({ isLoadingOralExamStatuses: true })
    return contentStore
      .loadExamStatus(true, true, EXAM_TYPE_ORAL)
      .then((practiceOralExam) => {
        this.setState({
          isLoadingOralExamStatuses: false,
          practiceOralExam,
        })
      })
  }
  loadExamStatuses = () => {
    const { contentStore } = this.props
    this.setState({ isLoadingExamStatuses: true })
    return Promise.all([
      contentStore.loadExamStatus(
        false, // isPractice
        true, // getOnly
      ),
      contentStore.loadExamStatus(true, true),
    ]).then(([exam, practiceExam]) => {
      this.setState({
        exam,
        isLoadingExamStatuses: false,
        practiceExam,
      })
    })
  }
  onChangeFilter = (event) => {
    const { practiceExam } = this.state
    const { target } = event
    const { value } = target
    const { filtersLearningObjectives } = practiceExam || {}
    const filters = filtersLearningObjectives || []
    const nextFilters =
      filters.indexOf(value) !== -1 // if filter exists
        ? filters.filter((f) => f !== value) // then remove existing filter
        : [...filters, value]
    practiceExam.filtersLearningObjectives = nextFilters
  }
  onChangeNumQuestions = (event) => {
    const { practiceExam } = this.state
    const { target } = event
    const { value } = target
    const { defaultQuestionCount } = practiceExam || {}
    const trimmedValue = value.trim()
    if (trimmedValue === '') {
      practiceExam.filtersNumQuestions = trimmedValue
      return
    } else if (!trimmedValue.match(/^[0-9]+$/)) {
      return
    }
    try {
      const numQuestions = parseInt(trimmedValue)
      practiceExam.filtersNumQuestions =
        numQuestions > defaultQuestionCount
          ? defaultQuestionCount
          : numQuestions
      return
    } catch {
      return
    }
  }
  onClickBack = () => {
    const { practiceExam } = this.state
    if (practiceExam) {
      practiceExam.resetFilters()
    }
    this.loadExamStatuses()
    return this.onClickHome()
  }
  onClickHome = () => this.setState({ view: EXAM_HOME_PAGE_HOME_VIEW })
  onClickReviewBack = (isPractice) => {
    this.setState({ examAttempt: null, examAttemptReview: null })
    return !isPractice ? this.onClickReviewTest() : this.onClickReviewPractice()
  }
  onClickReviewExam = (attempt, isPractice) => {
    this.setState({
      examAttemptReview: {
        attempt,
        isPractice,
      },
      view: EXAM_HOME_PAGE_REVIEW_EXAM_VIEW,
    })
  }
  onClickReviewPractice = () =>
    this.changeView(EXAM_HOME_PAGE_REVIEW_PRACTICE_VIEW)
  onClickReviewTest = () => this.changeView(EXAM_HOME_PAGE_REVIEW_TEST_VIEW)
  onClickStartPractice = () => {
    const { practiceExam } = this.state
    const { isStarted: isStartedPracticeExam } = practiceExam || {}
    if (!isStartedPracticeExam) practiceExam.startExam()
    return this.changeView(EXAM_HOME_PAGE_PRACTICE_VIEW)
  }
  onClickStartTest = () => {
    const { exam } = this.state
    const { isStarted: isStartedExam } = exam || {}
    if (!isStartedExam) exam.startExam()
    return this.changeView(EXAM_HOME_PAGE_TEST_VIEW)
  }
  onChangeOralExamFilter = (event) => {
    const { practiceOralExam } = this.state
    const { target } = event
    const { value } = target
    const { filtersLearningObjectives } = practiceOralExam || {}
    const filters = filtersLearningObjectives || []
    const nextFilters =
      filters.indexOf(value) !== -1
        ? filters.filter((f) => f !== value)
        : [...filters, value]
    practiceOralExam.filtersLearningObjectives = nextFilters
  }
  onChangeOralExamNumQuestions = (event) => {
    const { practiceOralExam } = this.state
    const { target } = event
    const { value } = target
    const { defaultQuestionCount } = practiceOralExam || {}
    const trimmedValue = value.trim()
    if (trimmedValue === '') {
      practiceOralExam.filtersNumQuestions = trimmedValue
      return
    } else if (!trimmedValue.match(/^[0-9]+$/)) {
      return
    }
    try {
      const numQuestions = parseInt(trimmedValue)
      practiceOralExam.filtersNumQuestions =
        numQuestions > defaultQuestionCount
          ? defaultQuestionCount
          : numQuestions
      return
    } catch {
      return
    }
  }
  loadOralExamAttempt = () => {
    const { contentStore } = this.props
    const { oralExamAttemptReview } = this.state
    const { attempt } = oralExamAttemptReview || {}
    return contentStore
      .loadExamAttempt(attempt, true, EXAM_TYPE_ORAL)
      .then((oralExamAttempt) => this.setState({ oralExamAttempt }))
  }
  loadOralExamAttempts = () => {
    const { contentStore } = this.props
    return contentStore
      .loadExamAttempts(true, EXAM_TYPE_ORAL)
      .then((practiceOralExamAttempts) =>
        this.setState({ practiceOralExamAttempts }),
      )
  }
  onClickReviewPracticeOralExam = () =>
    this.changeView(EXAM_HOME_PAGE_REVIEW_PRACTICE_ORAL_EXAM_VIEW)
  onClickReviewOralExam = (attempt) => {
    this.setState({
      oralExamAttemptReview: { attempt },
      view: EXAM_HOME_PAGE_REVIEW_ORAL_EXAM_VIEW,
    })
  }
  onClickReviewOralExamBack = () => {
    this.setState({ oralExamAttempt: null, oralExamAttemptReview: null })
    return this.onClickReviewPracticeOralExam()
  }
  onClickStartPracticeOralExam = () => {
    const { practiceOralExam } = this.state
    const { isStarted: isStartedPracticeOralExam } = practiceOralExam || {}
    if (!isStartedPracticeOralExam) practiceOralExam.startExam()
    return this.changeView(EXAM_HOME_PAGE_PRACTICE_ORAL_EXAM_VIEW)
  }
  onClickOralExamBack = () => {
    const { practiceOralExam } = this.state
    if (practiceOralExam) {
      practiceOralExam.resetFilters()
    }
    this.loadOralExamStatuses()
    return this.changeView(EXAM_HOME_PAGE_HOME_VIEW)
  }
  render() {
    const { contentStore } = this.props
    const {
      exam,
      examAttempt,
      examAttemptReview,
      examAttempts,
      isLoadingExamStatuses,
      isLoadingOralExamStatuses,
      oralExamAttempt,
      oralExamAttemptReview,
      practiceExam,
      practiceExamAttempts,
      practiceOralExam,
      practiceOralExamAttempts,
      tab,
      view,
    } = this.state
    const { course, settings } = contentStore || {}
    const { examEndless, examOnly, oralExam } = settings || {}
    const { displayTitle: courseDisplayTitle, title: courseTitle } = course
    const {
      defaultQuestionCount,
      filtersLearningObjectives,
      filtersNumQuestions,
    } = practiceExam || {}
    const {
      defaultQuestionCount: oralExamDefaultQuestionCount,
      filtersLearningObjectives: oralExamFiltersLearningObjectives,
      filtersNumQuestions: oralExamFiltersNumQuestions,
    } = practiceOralExam || {}
    const tabs = oralExam
      ? EXAM_HOME_PAGE_TABS
      : EXAM_HOME_PAGE_TABS.filter(
          (tab) => tab.id !== EXAM_HOME_PAGE_TAB_ORAL_EXAM,
        )
    return (
      <StudentLayout.Page className="ExamHomePage">
        <div className="ExamHomePage__outer-wrapper">
          {!examOnly && (
            <Link
              className="ExamHomePage__back-to-dashboard"
              isButton
              isInfo
              nav
              to="/dashboard"
            >
              &lt; Back to Dashboard
            </Link>
          )}
          <div className="ExamHomePage__inner-wrapper">
            <div className="ExamHomePage__header">
              <Heading className="ExamHomePage__header-title" is1>
                {courseTitle}
              </Heading>
            </div>
            <div className="ExamHomePage__tabs-wrapper">
              <Tabs
                active={tab}
                className="ExamHomePage__tabs"
                items={tabs}
                onChange={this.changeTab}
              />
            </div>
            {tab === EXAM_HOME_PAGE_TAB_EXAM ? (
              <ExamHomePageContent
                courseTitle={courseDisplayTitle || courseTitle}
                defaultQuestionCount={defaultQuestionCount}
                exam={exam}
                examAttempt={examAttempt}
                examAttemptReview={examAttemptReview}
                examAttempts={examAttempts}
                examEndless={examEndless}
                learningObjectives={filtersLearningObjectives}
                isLoadingExamStatuses={isLoadingExamStatuses}
                loadExamAttempt={this.loadExamAttempt}
                loadExamAttempts={this.loadExamAttempts}
                loadExamStatuses={this.loadExamStatuses}
                numQuestions={filtersNumQuestions}
                onChangeFilter={this.onChangeFilter}
                onChangeNumQuestions={this.onChangeNumQuestions}
                onClickBack={this.onClickBack}
                onClickHome={this.onClickHome}
                onClickReviewBack={this.onClickReviewBack}
                onClickReviewExam={this.onClickReviewExam}
                onClickReviewPractice={this.onClickReviewPractice}
                onClickReviewTest={this.onClickReviewTest}
                onClickStartPractice={this.onClickStartPractice}
                onClickStartTest={this.onClickStartTest}
                practiceExam={practiceExam}
                practiceExamAttempts={practiceExamAttempts}
                view={view}
              />
            ) : (
              <OralExamHomePageContent
                defaultQuestionCount={oralExamDefaultQuestionCount}
                isLoadingOralExamStatuses={isLoadingOralExamStatuses}
                learningObjectives={oralExamFiltersLearningObjectives}
                loadOralExamAttempt={this.loadOralExamAttempt}
                loadOralExamAttempts={this.loadOralExamAttempts}
                loadOralExamStatuses={this.loadOralExamStatuses}
                numQuestions={oralExamFiltersNumQuestions}
                onChangeFilter={this.onChangeOralExamFilter}
                onChangeNumQuestions={this.onChangeOralExamNumQuestions}
                onClickOralExamBack={this.onClickOralExamBack}
                onClickReviewOralExam={this.onClickReviewOralExam}
                onClickReviewOralExamBack={this.onClickReviewOralExamBack}
                onClickReviewPracticeOralExam={
                  this.onClickReviewPracticeOralExam
                }
                onClickStartPracticeOralExam={this.onClickStartPracticeOralExam}
                oralExamAttempt={oralExamAttempt}
                oralExamAttemptReview={oralExamAttemptReview}
                practiceOralExam={practiceOralExam}
                practiceOralExamAttempts={practiceOralExamAttempts}
                view={view}
              />
            )}
          </div>
        </div>
      </StudentLayout.Page>
    )
  }
}
